// @flow

import * as React from 'react';

import { selectCartUUID } from '@gandi/cart';
import { useTranslator } from '@gandi/translate';
import { Action, Divider } from '@gandi/ui/deprecated';

import { useAppSelector } from 'src/hooks';

import { selectGostackURL } from '../../modules/config';

export function CallToActionFooter(): React.MixedElement {
  const { __ } = useTranslator();
  const cartId = useAppSelector(selectCartUUID);
  const gostackUrl = useAppSelector(selectGostackURL);

  const actions = [];

  actions.push(
    <Action
      key="domain-action"
      to={`/domain/suggest/${cartId || ''}`}
      title={__('Register a domain')}
      variant="block"
      icon="domain"
    >
      {__('Domain')}
    </Action>,
  );

  actions.push(
    <Action
      key="certificate-action"
      to={`/certificate/create/${cartId || ''}`}
      title={__('Buy a SSL certificate')}
      variant="block"
      icon="security"
    >
      {__('SSL certificate')}
    </Action>,
  );

  actions.push(
    <Action
      key="shs-action"
      to={`/simplehosting/create/${cartId || ''}`}
      title={__('Host your web projects')}
      variant="block"
      icon="simplehosting"
    >
      {__('Web Hosting')}
    </Action>,
  );

  actions.push(
    <Action
      key="vps-action"
      href={gostackUrl}
      title={__('Create your fully customizable cloud infrastructure')}
      variant="block"
      icon="gostack"
    >
      {__('GandiCloud')}
    </Action>,
  );

  return (
    <Divider direction="columnToRow" spread="equal">
      {actions}
    </Divider>
  );
}
